import React from "react";
import "./Aboutus.css";
import Imageone from "../../../src/Assets/Images/OurTeam/ImageOne.webp";
import Imagetwo from "../../../src/Assets/Images/OurTeam/ImageTwo.webp";
import Imagethree from "../../../src/Assets/Images/OurTeam/ImageThree.webp";
import Imagefour from "../../../src/Assets/Images/OurTeam/ImageFour.webp";
import Imagefive from "../../../src/Assets/Images/OurTeam/ImageFive.webp";
import Imagesix from "../../../src/Assets/Images/OurTeam/ImageSix.webp";
import Imageseven from "../../../src/Assets/Images/OurTeam/ImageSeven.webp";
import Imageeight from "../../../src/Assets/Images/OurTeam/ImageEight.webp";
import Imagenine from "../../../src/Assets/Images/OurTeam/ImageNine.webp";
import Imageten from "../../../src/Assets/Images/OurTeam/ImageTen.webp";
import Imageeleven from "../../../src/Assets/Images/OurTeam/ImageEleven.webp";
import Imagetwelve from "../../../src/Assets/Images/OurTeam/ImageTwelve.webp";
import Imagethirteen from "../../../src/Assets/Images/OurTeam/ImageThirteen.webp";
import Imagefourteen from "../../../src/Assets/Images/OurTeam/ImageFourteen.webp";
import Imagefifteen from "../../../src/Assets/Images/OurTeam/ImageFifteen.webp";
import tripVideo from "../../../src/Assets/Images/OurTeam/tripvideo.MP4";

function AboutusImages() {
  return (
    <div>
      <div className="marqueeTeam">
        <ul className="marquee__contentTeam scrollTeam">
          <li>
            <img src={Imagenine} alt="" width="90%" />
          </li>
          <li>
            <img src={Imageten} alt="" width="90%" />
          </li>
          <li>
            <img src={Imageeleven} alt="" width="90%" />
          </li>

          <li>
            <img src={Imagetwelve} alt="" width="90%" />
          </li>
        </ul>
        <ul className="marquee__contentTeam scrollTeam">
          <li>
            <img src={Imageone} alt="" width="90%" />
          </li>
          <li>
            <img src={Imagetwo} alt="" width="90%" />
          </li>
          <li>
            <img src={Imagethree} alt="" width="90%" />
          </li>
          <li>
            <img src={Imagefour} alt="" width="90%" />
          </li>
        </ul>
      </div>

      <div className="marqueeTeam">
        <ul className="marquee__contentTeamTwo scrollTeamtwo">
          <li>
            <img src={Imagefive} alt="" width="90%" />
          </li>
          <li>
            <img src={Imagesix} alt="" width="90%" />
          </li>
          <li>
            <img src={Imageseven} alt="" width="90%" />
          </li>
          <li>
            <img src={Imageeight} alt="" width="90%" />
          </li>
        </ul>
        <ul className="marquee__contentTeamTwo scrollTeamtwo">
          <li>
            <img src={Imagethirteen} alt="" width="90%" />
          </li>
          <li>
            <img src={Imagefourteen} alt="" width="90%" />
          </li>
          <li>
            <img src={Imagefifteen} alt="" width="90%" />
          </li>
          <li>
            <img src={Imageeight} alt="" width="90%" />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AboutusImages;
